import React from 'react';

class ImpLinks extends React.Component {
    render() { 
        return <React.Fragment>
            <div className="unipadding imp-links">
            <div className="div25"><a href="#">
              <svg
                width="104"
                height="52"
                className="ease-animation-slow"
                enable-background="new 0 0 352 115.333"
                version="1.1"
                viewBox="0 0 352 115.333"
              >
                <path
                  fill="#142B6F"
                  d="M83.784,109.63L62.117,77.18c13.142-6.564,20.489-18.159,20.489-32.511	c0-21.472-16.011-37.617-44.441-37.617H5.232V109.63h18.426V82.282h20.054l17.986,27.348H83.784z M40.05,63.422H23.658V25.914H40.05	c13.055,0,23.209,5.842,23.209,18.755C63.26,57.578,53.105,63.422,40.05,63.422 M329.012,7.052h18.422V109.63h-18.422V7.052z M146.311,52.728v34.023c0.293,4.523,2.319,6.639,6.316,6.639c3.992,0,6.968-1.756,9.386-3.688v17.351	c-3.53,2.479-9.519,4.275-16.169,3.881c-4.423-0.264-9.607-2.161-13.243-5.9c-3.146-3.93-4.72-7.829-4.72-14.452V52.728h-9.421	v-16.66h9.421V12.132h18.43v23.936h12.572v16.66H146.311z M237.831,109.615h-16.523l-1.71-8.384	c-3.386,4.416-10.345,9.267-20.496,9.267c-18.24,0-30.638-10.736-30.638-30.301V36.069h18.231v37.983	c0,12.944,5.784,18.535,16.379,18.535c10.589,0,16.523-7.649,16.523-18.535V36.069h18.233V109.615z M319.535,36.158v73.472h-14.747	l-1.712-7.642c-3.085,3.968-11.164,8.522-21.011,8.522c-21.011,0-36.886-15.576-36.886-37.615c0-22.043,15.875-37.62,36.886-37.62	c9.697,0,17.926,4.556,21.011,8.523l1.712-7.641H319.535z M282.628,52.676c-11.188,0-19.813,9.167-19.813,20.22	c0,11.05,8.626,20.215,19.813,20.215c10.918,0,19.275-9.165,19.275-20.215C301.903,61.843,293.546,52.676,282.628,52.676 M91.493,36.066h18.425v73.562H91.493V36.066z M112.609,15.597c0,6.705-5.363,12.14-11.977,12.14	c-6.615,0-11.978-5.435-11.978-12.14c0-6.703,5.362-12.138,11.978-12.138C107.246,3.459,112.609,8.894,112.609,15.597"
                ></path>
              </svg></a>
            </div>
            <div className="div25">
              <ul>
                <li>SHOP</li>
                <li><a href="#">Multivitamin</a></li>
                <li><a href="#">Protien</a></li>
                <li><a href="#">Bundles</a></li>
                <li><a href="#">Gift Cards</a></li>
              </ul>
            </div>
            <div className="div25">
              <ul>
                <li>ABOUT</li>
                <li><a href="#">Ingredients</a></li>
                <li><a href="#">Who We are</a></li>
                <li><a href="#">Our Clinical Journey</a></li>
                <li><a href="#">The Journal</a></li>
                <li><a href="#">Riviews</a></li>
              </ul>
            </div>
            <div className="div25">
              <ul>
                <li>MORE</li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Press</a></li>
                <li><a href="#">Help</a></li>
              </ul>
            </div>
          </div>
        </React.Fragment>;
    }
}
 
export default ImpLinks;